import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
declare var $: any;
import * as _ from 'lodash';
import { NcdclientService } from 'src/app/services/NCD/ncdclient.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertComponent } from '../../alert/alert.component';
@Component({
  selector: 'app-allottes-library',
  templateUrl: './allottes-library.component.html',
  styleUrls: ['./allottes-library.component.css']
})
export class AllottesLibraryComponent implements OnInit {

  @Input('allotteeId') allotteeId: any;
  @Input('allotteeStatus') allotteeStatus: any;
  @Input('allotteeDetails') allotteeDetails: any;
  companyId = JSON.parse(localStorage.getItem('companyDetails')).companyID;

  alloteesForm: FormGroup;
  disabledOnclick: boolean;
  btnadd: boolean;
  numList: Array<string> = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
  dpTypeList = ['NSDL', 'CDSL'];
  isInvestorCodeUnique: boolean;
  investorCodeArray: any = [];
  existingAllotteesInvestorCodeList: any = [];

  constructor(private ncdClientService: NcdclientService, private alert: AlertComponent,
    public activeModal: NgbActiveModal) { }

  ngOnInit() {

    if (this.allotteeId == null) {
      this.btnadd = true;
    } else {
      this.btnadd = false;
    }
    this.alloteesForm = new FormGroup({
      srNo: new FormControl('', []),
      investorCode: new FormControl('', [Validators.required]),
      name: new FormControl('', [Validators.required]),
      addressLine1: new FormControl('', []),
      addressLine2: new FormControl('', []),
      addressLine3: new FormControl('', []),
      city: new FormControl('', []),
      state: new FormControl('', []),
      country: new FormControl('', []),
      pinCode: new FormControl('', []),
      email: new FormControl('', []),
      mobile: new FormControl('', []),
      PAN: new FormControl('', []),
      investorCategory: new FormControl('', []),
      investorSubCategory: new FormControl('', []),
      bankName: new FormControl('', []),
      IFSC: new FormControl('', []),
      virtualAccountNo: new FormControl('', []),
      dpType: new FormControl('', []),
      dpID: new FormControl('', []),
      benCliId: new FormControl('', []),
    });

    this.getExistingAllotteesInvestorCodeList();
    this.getAlloteeDetails();

  }

  noBlankSpaceAtStart(ev) {
    if (ev.which === 32 && ev.target.selectionStart === 0) {
      return false;
    }
  }

  onlyNumber(ev) {
    var keyCode = window.event ? ev.keyCode : ev.which;
    //codes for 0-9
    if ((keyCode > 47 && keyCode < 58) || (keyCode > 95 && keyCode < 106) || (keyCode > 34 && keyCode < 41) || (keyCode == 16) || (keyCode == 46) || (keyCode == 9)) {

      if (((keyCode > 47 && keyCode < 58) || (keyCode > 95 && keyCode < 106)) && this.numList.indexOf(ev.key) == -1) {
        ev.preventDefault();
      }
    }
    else {
      if (keyCode != 0 && keyCode != 8 && keyCode != 13 && !ev.ctrlKey) {
        ev.preventDefault();
      }
    }
  }

  onlyAlphabates(ev) {
    var charCode = window.event ? ev.keyCode : ev.which;
    //codes for 0-9
    if (!(charCode >= 65 && charCode <= 120) && (charCode != 32 && charCode != 0) && (charCode != 8) && (charCode != 46) && (charCode != 9)
      && (charCode >= 48 && charCode <= 57) || (charCode >= 96 && charCode <= 105)) {
      event.preventDefault();
    }
  }

  closeModal() {
    this.activeModal.close();
  }

  getExistingAllotteesInvestorCodeList() {
    this.ncdClientService.getExistingAllotteesList()
      .subscribe(response => {
        if (response.status == 0) {
          var self = this;
          response.data.forEach(function (o) {
            self.investorCodeArray.push(o.investorCode);
          });
          // console.log(self.investorCodeArray)

        } else {
          // this.alert.error(response.message);
        }
      });
  }

  onBlurCheckInvestorCode() {
    let investorCode = this.alloteesForm.controls.investorCode.value;
    if (this.investorCodeArray.includes(investorCode)) {
      this.isInvestorCodeUnique = true;
    } else {
      this.isInvestorCodeUnique = false;
    }
  }

  getAlloteeDetails() {
    $(document).ready(function () {
      $('.email').tagsInput({
        'unique': true,
        'interactive': true,
        'width': 'auto',
        'height': 'auto',
        'onAddTag': function (input, value) {

          if (!(/[a-z0-9._%+-]+@[a-z0-9.-]+[.]+[a-z0-9.-]{2,3}/.test(value))) {
            // console.log('------if-----------------', value)
            $('.email').removeTag(value);
          } else {

          }
        }
      })
      $('.email').importTags('');
      if (this.allotteeId != null) {
        $(".email").importTags((this.allotteeDetails.email) ? this.allotteeDetails.email : '');
      }
    })
    if (this.allotteeId != null) {

      // this.multipleEmails = this.allotteeDetails.email;


      this.alloteesForm.patchValue({
        srNo: this.allotteeDetails.srNo,
        investorCode: this.allotteeDetails.investorCode,
        name: this.allotteeDetails.name,
        addressLine1: this.allotteeDetails.addressLine1,
        addressLine2: this.allotteeDetails.addressLine2,
        addressLine3: this.allotteeDetails.addressLine3,
        city: this.allotteeDetails.city,
        state: this.allotteeDetails.state,
        country: this.allotteeDetails.country,
        pinCode: this.allotteeDetails.pinCode,
        email: this.allotteeDetails.email,
        mobile: this.allotteeDetails.mobile,
        PAN: this.allotteeDetails.PAN,
        investorCategory: this.allotteeDetails.investorCategory,
        investorSubCategory: this.allotteeDetails.investorSubCategory,
        bankName: this.allotteeDetails.bankName,
        IFSC: this.allotteeDetails.IFSC,
        virtualAccountNo: this.allotteeDetails.virtualAccountNo,
        dpType: this.allotteeDetails.dpType,
        dpID: this.allotteeDetails.dpID,
        benCliId: this.allotteeDetails.benCliId,
      })
    }

  }

  allotteeFormObjectForsaveAndUpdate() {
    this.disabledOnclick = true;
    let allotteesDetails = {
      CompanyID: this.companyId,
      srNo: this.alloteesForm.controls.srNo.value,
      investorCode: this.alloteesForm.controls.investorCode.value,
      name: this.alloteesForm.controls.name.value,
      addressLine1: this.alloteesForm.controls.addressLine1.value,
      addressLine2: this.alloteesForm.controls.addressLine2.value,
      addressLine3: this.alloteesForm.controls.addressLine3.value,
      city: this.alloteesForm.controls.city.value,
      state: this.alloteesForm.controls.state.value,
      country: this.alloteesForm.controls.country.value,
      pinCode: this.alloteesForm.controls.pinCode.value,
      email: $('.email').val(),
      mobile: this.alloteesForm.controls.mobile.value,
      PAN: this.alloteesForm.controls.PAN.value,
      investorCategory: this.alloteesForm.controls.investorCategory.value,
      investorSubCategory: this.alloteesForm.controls.investorSubCategory.value,
      bankName: this.alloteesForm.controls.bankName.value,
      IFSC: this.alloteesForm.controls.IFSC.value,
      virtualAccountNo: this.alloteesForm.controls.virtualAccountNo.value,
      dpType: this.alloteesForm.controls.dpType.value,
      dpID: this.alloteesForm.controls.dpID.value,
      benCliId: this.alloteesForm.controls.benCliId.value,
    }

    if (this.allotteeId == null) {
      this.ncdClientService.addAllotteesMaster(allotteesDetails)
        .subscribe((res: any) => {
          this.disabledOnclick = false;
          this.closeModal();
          if (res.status == 0) {
            this.alert.success("NCD allottees added successfully.");
          }
          else {
            if (res.err_fields) {
              this.alert.error(JSON.stringify(res.err_fields) + 'fields are required or invalid.');
            } else if (res.error) {
              this.alert.error(JSON.stringify(res.error) + '  fields are required or invalid');
            } else {
              this.alert.error(res.message);
            }
          }


        });
    } else {
      this.ncdClientService.updateAllotteesMaster(allotteesDetails, this.allotteeId)
        .subscribe((res: any) => {
          this.disabledOnclick = false;
          this.closeModal();
          if (res.status == 0) {
            this.alert.success("NCD allottees updated successfully.");
          }
          else {
            if (res.err_fields) {
              this.alert.error(JSON.stringify(res.err_fields) + '  fields are required or invalid');
            } else if (res.error) {
              this.alert.error(JSON.stringify(res.error) + '  fields are required or invalid');
            } else {
              this.alert.error(res.message);
            }
          }
        });
    }

  }

}


